import { TESTIMONIALS, AWARDS, CONTACT } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight } from "lucide-react";

export const Testimonials = () => (
  <section
    id="anbefalinger"
    data-testid="testimonials-section"
    className="bg-[#f4f4f2] text-[#141414] py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24">
        <Reveal className="lg:col-span-6">
          <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-6 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
            Anbefalinger
          </p>
          <h2 className="font-display font-light leading-[1.05] text-4xl md:text-5xl lg:text-6xl">
            Hvad ledere, teams og kunder siger.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-5 lg:col-start-8 self-end" delay={0.1}>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-linkedin-link"
            className="inline-flex items-center gap-2 font-ui text-sm uppercase tracking-[0.16em] text-[#2a2a28] border-b border-[#bfbfba] pb-1 hover:text-[#1f3d2b] hover:border-[#1f3d2b] transition-colors duration-300"
          >
            Se alle anbefalinger på LinkedIn
            <ArrowUpRight size={16} />
          </a>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-4 border-t border-[#141414]/10">
        {TESTIMONIALS.map((t, i) => (
          <Reveal
            key={t.name}
            delay={(i % 2) * 0.08}
            className="border-b border-[#141414]/10 md:[&:nth-last-child(-n+2)]:border-b-0"
          >
            <figure
              data-testid="testimonial-item"
              className="py-12 flex flex-col h-full"
            >
              <span className="font-display leading-none text-6xl text-[#1f3d2b]/25 mb-2">
                &ldquo;
              </span>
              <blockquote className="font-display font-light text-2xl md:text-[1.7rem] leading-[1.32] text-[#2a2a28] text-balance">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
                <div>
                  <div className="font-ui text-sm text-[#141414]">{t.name}</div>
                  <div className="font-ui text-xs uppercase tracking-[0.14em] text-[#6f6f6a]">
                    {t.title} · {t.relation}
                  </div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 md:mt-28">
        <Reveal>
          <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-8 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
            Anerkendelser
          </p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-[#141414]/10">
          {AWARDS.map((a, i) => (
            <Reveal
              key={i}
              delay={(i % 4) * 0.06}
              className="border-b border-[#141414]/10 lg:border-b-0 lg:border-r lg:last:border-r-0"
            >
              <div className="py-8 lg:px-6 lg:first:pl-0">
                <span className="font-ui text-xs text-[#1f3d2b] tracking-widest">
                  0{i + 1}
                </span>
                <p className="mt-3 font-display text-xl leading-snug text-[#2a2a28]">
                  {a}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
